import React, { useEffect, useState } from 'react';
import'./Blog.css'
import BlogCard from './BlogCard';

const truncateText = (text, maxLength) => {
   if (text.length <= maxLength) {
     return text;
   }
   return text.slice(0, maxLength) + '...';
 };



const Blog = () => {
   // const truncatedDescription = truncateText(description, 300);

    const [data ,setData] = useState();

    useEffect(() => {
    //    fetch("http://localhost:5000/blog")
      //  fetch("https://portflio-backend.vercel.app/blog")
       fetch("https://portfolio-server-tau-liart.vercel.app/api/blogs")

       .then(res => res.json())
       .then(data => setData(data))
   
   
    },[])
    return (
        <section id='project'>
           <h5>My Recent Writings</h5>
           <h2>Blogs</h2>

           {/* <div className="container project_container">
                   
                {
                    data?.data?.map((item) =>{
                        return(
                            <article key={item.id} className='project_item'>
                            <div className="project_item-image">
                               <img src={item.image} alt="" />
                            </div>
                            <h3>{item.title}</h3>
                             <div className="project_item-cta">
                     
                            <p>{item.description}</p>
                           
                             </div>
    
                        </article>
                        )
                    })
                }



             


           </div> */}
















            
           <div  className="container project_container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mt-10"
           >
        {data?.data?.slice(0, 3).map((item) => (
          <BlogCard key={item._id} item={item} />
        ))}
      </div>
   


        </section>
    );
};

export default Blog;